export default __webpack_public_path__ + "static/media/me-icon.ce00a428.webp";